import Loadable from 'react-loadable';

const TagPage = Loadable<any, any>({
  loader: () => import(/* webpackChunkName: "TagPage" */ './TagPage'),
  loading: () => null,
});

export default TagPage;
